export const contrastRatioAA = 4.5

export const sRgbLinearThreshold = 0.03928

export const contrastTranslationOptions = { nsSeparator: false, keySeparator: false }
